/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Step_2_DescriptionInputs */

const en_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`   `)
};

const ar_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_invite_page_step_2_description = /** @type {(inputs: Invite_Page_Step_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在邀請頁中的輸入邀請碼。`)
};

/**
* | output |
* | --- |
* | "" |
*
* @param {Invite_Page_Step_2_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_step_2_description = /** @type {((inputs?: Invite_Page_Step_2_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Step_2_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_step_2_description(inputs)
	if (locale === "ar") return ar_invite_page_step_2_description(inputs)
	if (locale === "de") return de_invite_page_step_2_description(inputs)
	if (locale === "es") return es_invite_page_step_2_description(inputs)
	if (locale === "fr") return fr_invite_page_step_2_description(inputs)
	if (locale === "it") return it_invite_page_step_2_description(inputs)
	if (locale === "ja") return ja_invite_page_step_2_description(inputs)
	if (locale === "ko") return ko_invite_page_step_2_description(inputs)
	if (locale === "pt_br") return pt_br_invite_page_step_2_description(inputs)
	if (locale === "ru") return ru_invite_page_step_2_description(inputs)
	if (locale === "th") return th_invite_page_step_2_description(inputs)
	if (locale === "tr") return tr_invite_page_step_2_description(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_step_2_description(inputs)
	return zh_tw_invite_page_step_2_description(inputs)
});